/* Park Greenport guide — v1.2.0 Business Search integration (2026-08-04). Adds: lazy-loaded business directory (assets/pg-businesses.json) merged into the destination search; tiered matching (exact name > exact alias > prefix > word-boundary > controlled fuzzy); haversine×1.3 distance ranking to business coordinates; accessible combobox (arrows/Enter/Escape, aria-activedescendant, live count). Fails soft: if the JSON can't load, the original destination search behaves exactly as before. Parking data, map, geometry, routing whitelist untouched. Namespace: pg. */
(function () {
  'use strict';
  var root = document.getElementById('pg-app');
  if (!root) return;
  var dataEl = document.getElementById('pg-data');
  if (!dataEl) return;
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var LOCS = DATA.locations || [];
  var DESTS = (DATA.settings && DATA.settings.destinations) || [];
  var byId = {};
  LOCS.forEach(function (l) { byId[l.id] = l; });
  var state = { dest: null, filter: 'all', view: 'home', drawerId: null, biz: null, bizWalk: null };
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollMode = reducedMotion ? 'auto' : 'smooth';
  var lastFocus = null;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var list = $('#pg-list'), title = $('#pg-results-title'), fallback = $('#pg-fallback');
  var search = $('#pg-search'), suggest = $('#pg-suggest'), searchEmpty = $('#pg-search-empty');
  var live = $('#pg-live'), onsite = $('#pg-onsite');
  var mapEl = $('#pg-map'), mapshell = $('#pg-mapshell');

  /* ---------- lazy map loader ---------- */
  var LCSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  var LCSS_SRI = 'sha384-sHL9NAb7lN7rfvG5lfHpm643Xkcjzp4jFvuavGOndn6pjVqS6ny56CAt3nsEVT4H';
  var LJS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  var LJS_SRI = 'sha384-cxOPjt7s7Iz04uaHJceBmS+qpjv2JkIHNVcuOrM+YHwZOmJGBXI00mdUXEq65HTH';
  function loadCss(href, sri) {
    return new Promise(function (res, rej) {
      if (document.querySelector('link[href="' + href + '"]')) return res();
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href;
      if (sri) { l.integrity = sri; l.crossOrigin = 'anonymous'; }
      l.onload = res; l.onerror = rej; document.head.appendChild(l);
    });
  }
  function loadJs(src, sri) {
    return new Promise(function (res, rej) {
      if (document.querySelector('script[src="' + src + '"]')) return res();
      var s = document.createElement('script');
      s.src = src;
      if (sri) { s.integrity = sri; s.crossOrigin = 'anonymous'; }
      s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
  }
  var geoReady = mapEl ? loadJs(mapEl.getAttribute('data-geo-js')).catch(function () {}) : Promise.resolve();
  var mapApi = null, booting = null;
  function bootMap() {
    if (!mapEl) return Promise.resolve();
    if (booting) return booting;
    booting = loadCss(LCSS, LCSS_SRI)
      .then(function () { return loadJs(LJS, LJS_SRI); })
      .then(function () { return Promise.all([geoReady, loadJs(mapEl.getAttribute('data-map-js'))]); })
      .then(function () {
        if (!mapApi && window.PG_MAP && window.PG_GEOMETRY) {
          mapApi = window.PG_MAP.mount(mapEl, {
            locations: LOCS, settings: DATA.settings, geometry: window.PG_GEOMETRY,
            onSelect: function (id) { openDrawer(id); }
          });
        }
      })
      .catch(function () { booting = null; /* placeholder text remains — weak-signal state */ });
    return booting;
  }
  if (mapEl) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); bootMap(); } }, { rootMargin: '400px' });
      io.observe(mapEl);
    } else { bootMap(); }
  }
  function showMapFor(id) {
    bootMap().then(function () {
      window.scrollTo({ top: mapshell.offsetTop - 8, behavior: scrollMode });
      if (mapApi) { mapApi.invalidate(); if (id) mapApi.focus(id); }
    });
  }

  /* ---------- business directory (v1.2.0) ----------
     Search-only destinations. Loaded lazily from assets/pg-businesses.json (URL in data-pg-biz).
     Normalized ONCE after load; matching per keystroke touches precomputed strings only.
     BIZ === null: not loaded yet. BIZ === []: load failed or empty — business search silently off. */
  var BIZ = null, bizLoading = null;
  function norm(s) {
    s = String(s || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return s.replace(/['\u2019]/g, '').replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function prep(b) {
    var seen = {}, al = [];
    (b.aliases || []).forEach(function (a) { var n = norm(a); if (n && !seen[n]) { seen[n] = 1; al.push(n); } });
    return { b: b, n: norm(b.name), a: al, street: String(b.address || '').split(',')[0] };
  }
  function loadBiz() {
    if (bizLoading) return bizLoading;
    var url = search && search.getAttribute('data-pg-biz');
    if (!url || typeof fetch !== 'function') { BIZ = []; bizLoading = Promise.resolve(); return bizLoading; }
    bizLoading = fetch(url).then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (j) { BIZ = (j && j.businesses || []).map(prep); })
      .catch(function () { BIZ = []; /* fail soft — destination search unaffected */ });
    return bizLoading;
  }
  if ('requestIdleCallback' in window) { requestIdleCallback(function () { loadBiz(); }, { timeout: 4000 }); }
  else { setTimeout(loadBiz, 3500); }

  /* Damerau-Levenshtein (small strings only), early exit via length guard at call site */
  function dl(a, b) {
    var i, j, la = a.length, lb = b.length, d = [];
    for (i = 0; i <= la; i++) { d[i] = [i]; }
    for (j = 0; j <= lb; j++) { d[0][j] = j; }
    for (i = 1; i <= la; i++) {
      for (j = 1; j <= lb; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
    }
    return d[la][lb];
  }
  function fuzzyHit(qtok, name) {
    var ntok = name.split(' ');
    return qtok.every(function (qt) {
      if (qt.length < 5) return ntok.indexOf(qt) !== -1; /* short tokens never fuzz */
      var max = qt.length <= 8 ? 1 : 2;
      return ntok.some(function (nt) { return Math.abs(nt.length - qt.length) <= max && dl(qt, nt) <= max; });
    });
  }
  /* Tiers: 0 exact name · 1 exact alias · 2 prefix · 3 word-boundary substring · 4 fuzzy (only if 0-3 empty).
     Sort: tier asc, search_priority desc, name-match before alias-match, alphabetical. */
  function matchBiz(nq) {
    if (!BIZ || !BIZ.length) return [];
    var out = [], i, r, t, s;
    for (i = 0; i < BIZ.length; i++) {
      r = BIZ[i]; t = null; s = 0;
      if (r.n === nq) t = 0;
      else if (r.a.indexOf(nq) !== -1) { t = 1; s = 1; }
      else if (r.n.indexOf(nq) === 0) t = 2;
      else if (r.a.some(function (a) { return a.indexOf(nq) === 0; })) { t = 2; s = 1; }
      else if ((' ' + r.n + ' ').indexOf(' ' + nq + ' ') !== -1) t = 3;
      else if (r.a.some(function (a) { return (' ' + a + ' ').indexOf(' ' + nq + ' ') !== -1; })) { t = 3; s = 1; }
      if (t !== null) out.push({ r: r, t: t, s: s });
    }
    if (!out.length) {
      var qtok = nq.split(' ');
      for (i = 0; i < BIZ.length; i++) {
        r = BIZ[i];
        if (fuzzyHit(qtok, r.n) || r.a.some(function (a) { return fuzzyHit(qtok, a); })) out.push({ r: r, t: 4, s: 0 });
      }
    }
    out.sort(function (x, y) {
      return (x.t - y.t) || ((y.r.b.search_priority || 0) - (x.r.b.search_priority || 0)) || (x.s - y.s) || (x.r.n < y.r.n ? -1 : 1);
    });
    return out;
  }

  /* ---------- distance ranking (business destinations) ----------
     Haversine straight-line × 1.3 street factor ÷ 80 m/min, rounded up (min 1).
     Parking coordinates = PG_GEOMETRY.anchors (display anchors; unchanged file). */
  function hav(lat1, lng1, lat2, lng2) {
    var R = 6371000, rad = Math.PI / 180;
    var dLat = (lat2 - lat1) * rad, dLng = (lng2 - lng1) * rad;
    var s = Math.sin(dLat / 2), c = Math.sin(dLng / 2);
    var h = s * s + Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * c * c;
    return 2 * R * Math.asin(Math.sqrt(h));
  }
  function computeBizWalks() {
    var GEO = window.PG_GEOMETRY || {};
    var A = GEO.anchors, R = GEO.routing || {};
    if (!A || !state.biz) return;
    if (state.biz.destination_group === 'Outside downtown core') return; /* on-site parking — skip lot ranking */
    var w = {};
    LOCS.forEach(function (l) {
      /* corridors (GP-01/GP-02) have no display anchor — fall back to their routing mid-zone point */
      var c = A[l.id] || R[l.id];
      if (c) w[l.id] = Math.max(1, Math.ceil(hav(state.biz.lat, state.biz.lng, c.lat, c.lng) * 1.3 / 80));
    });
    state.bizWalk = w;
  }

  /* ---------- list logic ---------- */
  function destObj(key) { for (var i = 0; i < DESTS.length; i++) if (DESTS[i].key === key) return DESTS[i]; return null; }
  function walkOf(l) {
    if (state.dest === 'biz') return state.bizWalk && state.bizWalk[l.id] != null ? state.bizWalk[l.id] : 99;
    return (l.walk && l.walk[state.dest || 'main']) != null ? l.walk[state.dest || 'main'] : 99;
  }
  function setView(v) { state.view = v; root.setAttribute('data-view', v); window.scrollTo({ top: 0, behavior: scrollMode }); }
  function render() {
    var cards = $$('.pg-card');
    var visible = [];
    cards.forEach(function (c) {
      var l = byId[c.getAttribute('data-pg-id')];
      if (!l) return;
      var ok = true;
      if (state.filter === 'free') ok = l.cls === 'free' || l.cls === 'timed';
      if (state.filter === 'lots') ok = String(l.isLot) === 'true';
      c.hidden = !ok;
      if (ok) visible.push(c);
      var w = c.querySelector('[data-pg-walk]');
      if (w) {
        if (state.dest === 'biz') { w.textContent = state.bizWalk && state.bizWalk[l.id] != null ? state.bizWalk[l.id] : '\u2013'; }
        else if (l.walk) { w.textContent = l.walk[state.dest || 'main']; }
      }
    });
    var fell = visible.length === 0;
    if (fell) { cards.forEach(function (c) { c.hidden = false; }); visible = cards; }
    if (fallback) fallback.hidden = !fell;
    visible.sort(function (a, b) {
      var la = byId[a.getAttribute('data-pg-id')], lb = byId[b.getAttribute('data-pg-id')];
      var pa = (la.cls === 'private' || la.cls === 'moto') ? 100 : 0;
      var pb = (lb.cls === 'private' || lb.cls === 'moto') ? 100 : 0;
      return (walkOf(la) + pa) - (walkOf(lb) + pb);
    });
    visible.forEach(function (c) { list.appendChild(c); });
    var best = null;
    for (var i = 0; i < visible.length; i++) {
      var l = byId[visible[i].getAttribute('data-pg-id')];
      if (l.cls !== 'private' && l.cls !== 'moto') { best = visible[i]; break; }
    }
    cards.forEach(function (c) { var el = c.querySelector('.pg-best'); if (el) el.hidden = (c !== best); });
    if (title) {
      if (state.dest === 'biz' && state.biz) { title.textContent = 'Parking near ' + state.biz.name; }
      else { var d = destObj(state.dest); title.textContent = d ? 'Parking near ' + d.label.split(' (')[0] : 'All parking in Greenport'; }
    }
  }
  function clearBiz() { state.biz = null; state.bizWalk = null; if (onsite) onsite.hidden = true; }
  function pick(key) { clearBiz(); state.dest = key; state.filter = 'all'; syncFilterChips(); if (search) search.value = ''; hideSearchPanels(); setView('results'); render(); }
  function pickBusiness(b) {
    state.dest = 'biz'; state.biz = b; state.bizWalk = null; state.filter = 'all';
    syncFilterChips(); if (search) search.value = ''; hideSearchPanels();
    if (onsite) onsite.hidden = b.destination_group !== 'Outside downtown core';
    setView('results');
    if (window.PG_GEOMETRY) { computeBizWalks(); render(); }
    else { render(); geoReady.then(function () { if (state.dest === 'biz' && state.biz === b) { computeBizWalks(); render(); } }); }
  }
  function showAll() { clearBiz(); state.dest = null; state.filter = 'all'; syncFilterChips(); hideSearchPanels(); setView('results'); render(); }
  function syncFilterChips() {
    $$('.pg-fchip[data-pg-filter]').forEach(function (c) {
      var on = c.getAttribute('data-pg-filter') === state.filter;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- combobox search (v1.2.0 accessibility upgrade) ---------- */
  var options = [], activeIdx = -1;
  function setExpanded(v) { if (search) search.setAttribute('aria-expanded', v ? 'true' : 'false'); }
  function clearActive() { activeIdx = -1; if (search) search.setAttribute('aria-activedescendant', ''); }
  function hideSearchPanels() {
    if (suggest) { suggest.hidden = true; }
    if (searchEmpty) searchEmpty.hidden = true;
    options = []; clearActive(); setExpanded(false);
  }
  function setActive(i) {
    if (activeIdx >= 0 && options[activeIdx]) { options[activeIdx].classList.remove('is-active'); options[activeIdx].setAttribute('aria-selected', 'false'); }
    activeIdx = i;
    var o = options[i];
    o.classList.add('is-active'); o.setAttribute('aria-selected', 'true');
    search.setAttribute('aria-activedescendant', o.id);
    if (o.scrollIntoViewIfNeeded) o.scrollIntoViewIfNeeded(false);
  }
  function announce(n) {
    if (!live) return;
    live.textContent = n === 0 ? 'No matches found. Suggestions to report a missing spot are shown below.'
      : n + (n === 1 ? ' suggestion' : ' suggestions') + ' available. Use up and down arrow keys to review.';
  }
  function mkOpt(label, sub, onPick) {
    var b = document.createElement('button');
    b.type = 'button'; b.setAttribute('role', 'option'); b.setAttribute('aria-selected', 'false');
    var wrap = document.createElement('span'); wrap.className = 'pg-sug-main';
    var nameEl = document.createElement('span'); nameEl.textContent = label; wrap.appendChild(nameEl);
    if (sub) { var subEl = document.createElement('span'); subEl.className = 'pg-sug-sub'; subEl.textContent = sub; wrap.appendChild(subEl); }
    b.appendChild(wrap);
    b.addEventListener('click', onPick);
    return b;
  }
  function renderSuggest(destHits, bizHits) {
    suggest.innerHTML = ''; options = []; clearActive();
    destHits.forEach(function (d) { options.push(mkOpt(d.label, '', function () { pick(d.key); })); });
    bizHits.forEach(function (h) {
      var b = h.r.b;
      options.push(mkOpt(b.name, (b.category ? b.category + ' \u00b7 ' : '') + h.r.street, function () { pickBusiness(b); }));
    });
    options.forEach(function (o, i) { o.id = 'pg-opt-' + i; suggest.appendChild(o); });
    suggest.hidden = options.length === 0;
    setExpanded(options.length > 0);
    announce(options.length);
  }
  function destMatches(lq) {
    return DESTS.filter(function (d) {
      return d.label.toLowerCase().indexOf(lq) !== -1 || (d.synonyms || []).some(function (s) { return s.indexOf(lq) === 0 || lq.indexOf(s) !== -1; });
    }).slice(0, 4);
  }
  function runSearch() {
    var q = search.value.trim();
    var nq = norm(q);
    if (nq.length < 2) { hideSearchPanels(); return; }
    var destHits = destMatches(q.toLowerCase());
    var finish = function () {
      var bizHits = matchBiz(nq).slice(0, Math.max(0, 7 - destHits.length));
      if (destHits.length || bizHits.length) {
        renderSuggest(destHits, bizHits);
        searchEmpty.hidden = true;
      } else {
        suggest.hidden = true; options = []; clearActive(); setExpanded(false);
        searchEmpty.hidden = false; announce(0);
      }
    };
    if (BIZ !== null) { finish(); }
    else {
      if (destHits.length) { renderSuggest(destHits, []); searchEmpty.hidden = true; }
      loadBiz().then(function () { if (norm(search.value.trim()) === nq) finish(); });
    }
  }
  if (search) {
    search.addEventListener('input', runSearch);
    search.addEventListener('focus', function () { loadBiz(); });
    search.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hideSearchPanels(); return; }
      if (suggest.hidden || !options.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive((activeIdx + 1) % options.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((activeIdx - 1 + options.length) % options.length); }
      else if (e.key === 'Enter') {
        if (activeIdx >= 0) { e.preventDefault(); options[activeIdx].click(); }
        else if (options.length === 1) { e.preventDefault(); options[0].click(); }
      }
    });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-pg-dest],[data-pg-showall],[data-pg-showmap],[data-pg-filter],[data-pg-sources],.pg-card,#pg-back,#pg-somewhere,#pg-drawer-close,#pg-drawer-showmap,#pg-src-close,#pg-overlay,#pg-src-overlay') : null;
    if (!t) return;
    if (t.hasAttribute && t.hasAttribute('data-pg-dest')) return pick(t.getAttribute('data-pg-dest'));
    if (t.hasAttribute && t.hasAttribute('data-pg-showall')) return showAll();
    if (t.hasAttribute && t.hasAttribute('data-pg-showmap')) return showMapFor(null);
    if (t.hasAttribute && t.hasAttribute('data-pg-filter')) { state.filter = t.getAttribute('data-pg-filter'); syncFilterChips(); render(); return; }
    if (t.hasAttribute && t.hasAttribute('data-pg-sources')) return openSources();
    if (t.id === 'pg-back') return setView('home');
    if (t.id === 'pg-somewhere') { if (search) search.focus(); return; }
    if (t.id === 'pg-drawer-close' || t.id === 'pg-overlay') return closeDrawer();
    if (t.id === 'pg-drawer-showmap') { var id = state.drawerId; closeDrawer(); return showMapFor(id); }
    if (t.id === 'pg-src-close' || t.id === 'pg-src-overlay') return closeSources();
    if (t.classList && t.classList.contains('pg-card')) return openDrawer(t.getAttribute('data-pg-id'));
  });
  root.addEventListener('keydown', function (e) {
    var isCard = e.target.classList && e.target.classList.contains('pg-card');
    if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && isCard) {
      e.preventDefault();
      openDrawer(e.target.getAttribute('data-pg-id'));
    }
    if (e.key === 'Escape') { closeDrawer(); closeSources(); }
  });

  /* ---------- detail drawer ---------- */
  var drawer = $('#pg-drawer'), overlay = $('#pg-overlay');
  function openDrawer(id) {
    var l = byId[id];
    if (!l || !drawer) return;
    lastFocus = document.activeElement;
    state.drawerId = id;
    var chip = $('#pg-drawer-chip');
    chip.textContent = l.chip; chip.className = 'pg-chip pg-chip--' + l.cls;
    var acc = $('#pg-drawer-access');
    if (l.accessibleSpaces) { acc.textContent = l.accessibleSpaces + ' accessible spaces'; acc.hidden = false; } else acc.hidden = true;
    $('#pg-drawer-name').textContent = l.name;
    $('#pg-drawer-sub').textContent = l.subDetail || '';
    var walkBox = $('#pg-drawer-walk');
    walkBox.innerHTML = '';
    var wb = document.createElement('b'), ws = document.createElement('small');
    if (state.dest === 'biz' && state.biz) {
      wb.textContent = (state.bizWalk && state.bizWalk[l.id] != null ? 'about ' + state.bizWalk[l.id] : '\u2013') + ' min walk';
      ws.textContent = ' to ' + state.biz.name;
    } else {
      var d = destObj(state.dest);
      wb.textContent = (l.walk ? l.walk[state.dest || 'main'] : '\u2013') + ' min walk';
      ws.textContent = ' to ' + (d ? d.label.split(' (')[0] : 'Main Street');
    }
    walkBox.appendChild(wb); walkBox.appendChild(ws);
    var warn = $('#pg-drawer-warn');
    if (l.warning) { warn.textContent = l.warning; warn.hidden = false; } else warn.hidden = true;
    var qual = $('#pg-drawer-qual');
    if (l.qualifier) { qual.textContent = l.qualifier; qual.hidden = false; } else qual.hidden = true;
    var facts = $('#pg-drawer-facts');
    facts.innerHTML = '';
    (l.facts || []).forEach(function (f) {
      var box = document.createElement('div'); box.className = 'pg-fact';
      var k = document.createElement('div'); k.className = 'pg-fact-k'; k.textContent = f.label;
      var v = document.createElement('div'); v.className = 'pg-fact-v' + (f.positive ? ' is-good' : ''); v.textContent = f.value;
      box.appendChild(k); box.appendChild(v); facts.appendChild(box);
    });
    var ent = $('#pg-drawer-entrance');
    if (l.entrance) { ent.textContent = '\u21b3 ' + l.entrance; ent.hidden = false; } else ent.hidden = true;
    /* directions: rendered only for records whitelisted in parking-geometry.js (dataset navigate-to coordinates). Note text comes from the record's directions_note field; a geometry note (GP-07 hazard) overrides. */
    var dir = $('#pg-drawer-directions'), note = $('#pg-drawer-note');
    var R = window.PG_GEOMETRY && window.PG_GEOMETRY.routing && window.PG_GEOMETRY.routing[l.id];
    if (R) {
      dir.innerHTML = '<a class="pg-btn pg-btn--primary" target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' + R.lat + ',' + R.lng + '">Directions · Google Maps</a>' +
        '<a class="pg-btn pg-btn--ghost" target="_blank" rel="noopener" href="https://maps.apple.com/?daddr=' + R.lat + ',' + R.lng + '">Apple Maps</a>';
      dir.hidden = false;
      note.textContent = R.note || l.directionsNote || '';
    } else {
      dir.hidden = true; dir.innerHTML = '';
      note.textContent = 'Directions will be enabled once this location\u2019s entrance is verified on site. Posted signs govern.';
    }
    $('#pg-drawer-verified').textContent = '\u2713 Verified ' + (l.verified || '') + ' \u00b7 signs govern';
    overlay.hidden = false; drawer.hidden = false;
    drawer.setAttribute('tabindex', '-1'); drawer.focus();
  }
  function closeDrawer() {
    if (drawer) drawer.hidden = true;
    if (overlay) overlay.hidden = true;
    state.drawerId = null;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    lastFocus = null;
  }

  var src = $('#pg-sources'), srcOv = $('#pg-src-overlay');
  function openSources() {
    if (!src) return;
    lastFocus = document.activeElement;
    src.hidden = false; srcOv.hidden = false;
    src.setAttribute('tabindex', '-1'); src.focus();
  }
  function closeSources() {
    if (!src || src.hidden) return;
    src.hidden = true; srcOv.hidden = true;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    lastFocus = null;
  }

  setView('home');
  syncFilterChips();
  render();
})();
